import { Box, BoxProps } from "@mui/material";

export const WfDialogFooter = ({ children, ...props }: BoxProps) => {
    return (
        <Box
            {...props}
            sx={[
                {
                    position: { xs: "absolute", sm: "static" },
                    bottom: { xs: "24px", sm: "unset" },
                    width: { xs: "calc(100% - 48px)", sm: "auto" },
                },
                ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
            ]}
        >
            {children}
        </Box>
    );
};
